import { combineReducers } from "redux";
import filters from "./overviewFilters";
import timeSeries from "./overviewTimeSeries";
import accountSeries from "./overviewAccountSeries";

const overview = combineReducers({ filters, timeSeries, accountSeries });

export default overview;



// WEBPACK FOOTER //
// ./src/reducers/overview.js